import { EMPTY, MonoTypeOperatorFunction, catchError, finalize } from 'rxjs';
import { tap } from 'rxjs';
import {
  createRetryFetch$,
  flog,
  createDistributedObservable$,
} from '@lseg-ciam/auth/utils';
import type { TokenUpdate } from '@lseg-ciam/auth/token';

export function postCdnToken$(token: string) {
  return createRetryFetch$('/auth/heimdall', {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
    skipParse: true,
  });
}

export function deleteCdnCookie$(persist = false) {
  return createRetryFetch$(`/auth/heimdall${persist ? '?persist=true' : ''}`, {
    method: 'DELETE',
    skipParse: true,
  });
}

const CDN_LOCK = 'heimdall:cdn-relay';

export function withCdnRelay(): MonoTypeOperatorFunction<TokenUpdate> {
  return (source$) =>
    createDistributedObservable$<TokenUpdate>(CDN_LOCK, (o) =>
      source$
        .pipe(
          tap((update) => {
            postCdnToken$(update.token)
              .pipe(
                flog('CDN relay'),
                catchError(() => EMPTY)
              )
              .subscribe();
          }),
          finalize(() => {
            deleteCdnCookie$()
              .pipe(
                flog('CDN teardown'),
                catchError(() => EMPTY)
              )
              .subscribe();
          })
        )
        .subscribe(o)
    );
}
